import { render, staticRenderFns } from "./BranchInfo.vue?vue&type=template&id=365c458c&scoped=true&"
import script from "./BranchInfo.vue?vue&type=script&lang=js&"
export * from "./BranchInfo.vue?vue&type=script&lang=js&"
import style0 from "./BranchInfo.vue?vue&type=style&index=0&id=365c458c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365c458c",
  null
  
)

export default component.exports